<template>
  <v-row no-gutters>
    <v-col>
      <template
        v-for="(r, ri) in headerRows">
        <v-row v-if="r.showGroupHeader"
        :key="'rgh' + ri"
        no-gutters
        class="flex-nowrap">
          <v-col class="first-column group-header sub-row" style="min-width: 100%;"
          ><div
            :style="{ marginLeft: 8 + (r.item.indentLevel * 25) + 'px' }">
            {{r.showGroupHeader}}
          </div></v-col>
        </v-row>
      <v-row
        :key="'r' + ri"
        no-gutters
        class="flex-nowrap"
      >
        <v-col v-if="rowSelectable" 
          style="min-width: 40px;" 
          class="first-column row-header-selector"
          :class="r.cssClass">
          <CheckBox :item="r" @click="$emit('selectRow', r)" style="margin-left: -4px;"></CheckBox>
        </v-col>
        <v-col
          :style="{
            minWidth: rowSelectable ? 'calc(' + r.width.percent + ' - 40px)' : r.width.percent,
            maxWidth: rowSelectable ? 'calc(' + r.width.percent + ' - 40px)' : r.width.percent,
            color: r.item.displayStyle?.color,
            backgroundColor: r.item.displayStyle?.backgroundColor,
            height: r.height,
          }"
          :class="(r.cssClass || '') + ' col-resizable' + (r.item.isDescriptor ? ' descriptor-col' : '')"
        >
          <div v-if="r.width.key && !r.isGroupHeader" class="col-resize-handle" title="Drag to resize; double-click to reset"
            @click.stop
            @dblclick.stop="$emit('resetColumnWidth', r.width.key)"
            @pointerdown.stop.prevent="$emit('resizeColumn', $event, r.width.key, r.width.px)"></div>
          <div v-if="r.isGroupHeader"
            :style="{ marginLeft: 8 + (r.item.indentLevel * 25) + 'px' }">
            {{r.item.title}}
          </div>
          <RowHeader v-else
            :item="r.item"
            :indentNode="false"
            axis="verAxisSelected"
            :catalogueDocType="catalogueDocType"
            :searchTerms="searchTerms"
            :hideNodeActions="hideNodeActions"
            @openDocActionsMenuContext="
              $emit('openDocActionsMenuContext', $event, r.item)
            "
            @openDocument="$emit('openDocument', $event)"
            @copyDocument="$emit('copyDocument', $event)"
            @showMatches="$emit('showMatches', r.item)"
            @selectJob="$emit('selectJob', r)"
            @doMenuAction="
              $emit('doMenuAction', $event, r.item, 'verAxisSelected')
            "
            @nodeSelected="$emit('nodeSelected', r.item)"
            @viewNodeDoc="$emit('viewNodeDoc', $event, r.item)"
            @saveDescriptor="$emit('saveDescriptor', ...arguments)"
          >
          </RowHeader>
        </v-col>
        <v-col
          v-if="r.isDetail && !r.showTotalColumn && !r.isGroupHeader"
          :style="{ height: r.height, minWidth: r.width.remainder, maxWidth: r.width.remainder }"
        >
          <v-row class="flex-nowrap" no-gutters v-if="!r.isGroupHeader">
            <v-col
              :class="r.cssClassMeasure + m.cssClass + (mi === visibleMeasures.length - 1 ? r.cssClassMeasureLast : '') + ' col-resizable'"
              :style="{ height: r.height, minWidth: m.widthPct, maxWidth: m.widthPct }"
              v-for="(m, mi) in visibleMeasures"
              :key="'r' + ri + 'm' + mi"
            >
              <div class="col-resize-handle" title="Drag to resize; double-click to reset"
                @click.stop
                @dblclick.stop="$emit('resetColumnWidth', 'VM:' + (m.id || m.column))"
                @pointerdown.stop.prevent="$emit('resizeColumn', $event, 'VM:' + (m.id || m.column), m.widthPx)"></div>
              <MeasureDisplay class="row-header-measure"
                :item="r.item"
                :measure="m"
                :selectable="m.type === 'job_count'"
                @click="$emit('selectJob', r.item)"
                @showDocList="$emit('showDocList', $event)"
                @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
                @drilldown="$emit('drilldown', ...arguments)"
              ></MeasureDisplay>
            </v-col>
            <!-- <v-col cols="1" style="background-color: lightgreen"
              > {{visibleMeasures.length}}
            </v-col> -->
          </v-row>
        </v-col>
        <v-col
          v-else-if="r.subRows.length"
          :style="{ minWidth: r.width.remainder, maxWidth: r.width.remainder }"
        >
          <RowHeaders
            :headerRows="r.subRows"
            :visibleMeasures="visibleMeasures"
            :catalogueDocType="catalogueDocType"
            :rowSelectable="false"
            :searchTerms="searchTerms"
            @openDocumentID="$emit('openDocumentID', $event)"
            @openDocActionsMenuContext="
              (event, item) => $emit('openDocActionsMenuContext', event, item)
            "
            @openDocument="$emit('openDocument', $event)"
            @copyDocument="$emit('copyDocument', $event)"
            @showMatches="(event, item) => $emit('showMatches', item)"
            @selectJob="$emit('selectJob', $event)"
            @doMenuAction="
              (event, item, axis) => $emit('doMenuAction', event, item, axis)
            "
            @viewNodeDoc="(event, item) => $emit('viewNodeDoc', event, item)"
            @saveDescriptor="$emit('saveDescriptor', ...arguments)"
            @drilldown="$emit('drilldown', ...arguments)"
            @resizeColumn="$emit('resizeColumn', ...arguments)"
            @resetColumnWidth="$emit('resetColumnWidth', ...arguments)"
          ></RowHeaders>
        </v-col>
      </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
// import HierarchyViewColumnHeading from "@/components/jobArchitecture/HierarchyViewColumnHeadingAlt";
import RowHeader from "@/components/jobArchitecture/RowHeader";
import MeasureDisplay from "@/components/jobArchitecture/MeasureDisplay.vue";
import CheckBox from "@/components/jobArchitecture/CheckBox";

export default {
  name: "RowHeaders",
  components: {
    // HierarchyViewColumnHeading,
    RowHeader,
    MeasureDisplay,
    CheckBox,
  },
  props: {
    headerRows: { type: [], required: true },
    visibleMeasures: { type: [], required: true },
    catalogueDocType: { type: Object, required: false },
    rowSelectable: { type: Boolean, required: false, default: false },
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false, default: false },
  },
  data: function () {
    return {
      response: null,
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";

/* positioning context for the absolutely-filled description cell */
.descriptor-col {
  position: relative;
}
</style>
